import React, { useState, useCallback, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { useSnackbar } from 'notistack';

import { Toolbar, TableList } from './components';
import api from 'services/api';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  }
}));

const OwnerList = () => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const [users, setFarms] = useState([]);

  const fetchFarms = useCallback(async () => {
    try {
      const response = await api.get('owners');

      setFarms(response.data);
    } catch (err) {
      enqueueSnackbar('Não foi possível carregar os dados. Verifique sua conexão com a internet!', {
        variant: 'error',
      });
    }
  }, [enqueueSnackbar, setFarms]);

  useEffect(() => {
    fetchFarms();
  }, [fetchFarms]);

  return (
    <div className={classes.root}>
      <Toolbar fetchList={fetchFarms} />
      <div className={classes.content}>
        <TableList list={users} onFetch={fetchFarms} />
      </div>
    </div>
  );
};

export default OwnerList;
